export const SELECTED_PRODUCTS_LIMIT = 5;

export const TABLE_COLUMN_WIDTH = 190;
